// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { TradingUnlockMessageResponse } from '../Messages/TradingUnlockMessageResponse';
export class TradingUnlockResponseProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const msg = new TradingUnlockMessageResponse(fieldSet);
        return [msg];
    }
}
